import type { Dictionnaire } from '../type';

export const moderation: Dictionnaire['moderation'] = {
  erreurs: {
    compteOfficiel: '应用官方账号不能被举报。有任何问题都可以给它发消息。',
  },
  contenu: {
    supprime: '（内容已删除）',
    sansTexte: '（无文字）',
  },
  merci: {
    emailParti: '如果该账号存在，邮件正在路上。',
    post: '谢谢，我们的团队会处理。你将不再看到这条帖子。',
    signalement: '举报已发送。谢谢，我们会处理。',
    sortie: '谢谢，我们的团队会处理。你将不再看到这个活动。',
    simple: '谢谢，我们的团队会处理。',
    membre: '谢谢，我们的团队会处理。在此期间，这位成员已被屏蔽。',
    support: '消息已发送。我们的团队会通过邮件回复。',
  },
  raisons: {
    spam: '垃圾信息',
    harassment: '骚扰',
    shocking: '令人不适的内容',
    misinformation: '虚假信息',
    other: '其他',
  },
  admin: {
    durees: {
      jour: '24 小时',
      semaine: '7 天',
      mois: '30 天',
      sansTerme: '无期限',
    },
    echec: '操作没有成功。',
    fait: (geste: string) => `${geste}：已完成。`,
    gestes: {
      avertir: '警告',
      liberer: '恢复发言',
      museler: '禁言',
      retablir: '恢复账号',
      suspendre: '停用账号',
      suspendreQ: '停用这个账号？',
      retirerCoche: '移除认证标记',
      poserCoche: '添加认证标记',
      nommerModerateur: '设为审核员',
      nommerAdmin: '设为管理员',
      retirerRole: '移除角色',
      supprimer: '删除账号',
      supprimerQ: '删除这个账号及其发布的全部内容？删除后无法恢复。',
    },
    titre: '管理',
    chercherMembre: '搜索成员',
    sonPseudo: '对方的用户名',
    chercher: '搜索',
    personne: '没有这个用户名的成员',
    autre: '← 搜索其他人',
    rien: '无记录',
    avertissements: '警告',
    texteMembre: '成员将看到的内容',
    pourquoi: '原因（保留在日志中）',
    etat: {
      administrateur: '管理员',
      moderateur: '审核员',
      verifie: '已认证',
      suspendu: '已停用',
      muetJusqua: (date: string) => `禁言至 ${date}`,
      muet: '禁言，无期限',
      signalements: (n: number) => `${n} 条举报`,
      avertissements: (n: number) => `${n} 次警告`,
      lu: '已读',
      pasLu: '尚未阅读',
    },
  },
  avertissement: {
    titre: '警告',
    compris: '我知道了',
  },
  file: {
    onglets: {
      ouverts: '待处理',
      traites: '已处理',
      tout: '全部',
    },
    natures: {
      post: '帖子',
      comment: '评论',
      event: '活动',
      user: '成员',
      conversation: '对话',
      help: '求助消息',
    },
    masque: '内容已隐藏。',
    suspendu: '成员已停用。',
    classe: '举报已结案。',
    titre: '内容审核',
    masquer: '隐藏内容',
    suspendre: '停用该成员',
    classer: '不处理并结案',
    rienATraiter: '没有待处理的事项',
    rienIci: '这里什么都没有',
    aucunEnAttente: '没有待处理的举报。这是个好兆头。',
    traitesIci: '已处理的举报会出现在这里。',
    etatMasque: '内容已隐藏',
    etatSuspendu: '成员已停用',
    etatClasse: '未处理并结案',
    traiter: '处理',
    suspendreQ: (nom: string) => `停用 ${nom}？在恢复之前，对方将无法访问。`,
    signalements: (n: number) => `${n} 条举报`,
    signalePar: (nom: string) => `由 ${nom} 举报`,
  },
  signaler: {
    quoi: {
      post: '这条帖子',
      comment: '这条回复',
      event: '这个活动',
      member: '这位成员',
      conversation: '这个对话',
    },
    impossible: '暂时无法发送。',
    titre: '举报',
    indisponible: '这个内容已不可用。',
    envoyer: '发送',
    motif: '举报原因是什么？',
    detail: '如有需要，请补充细节',
    detailExemple: '可选：发生了什么，从什么时候开始。',
    intro: (quoi: string) => `告诉我们${quoi}有什么问题。我们的团队会审阅每一条举报，被举报的人不会收到通知。`,
  },
};
